<template>
  <div class="follow">

    <div class="upload">
        <p @click="upload()">上传我的医疗资料</p>
    </div>

    <mu-tabs :value.sync="active"
             @change="tabChange"
             class="tab"
             inverse
             color="#3B9CFD"
             indicator-color="#3B9CFD"
             center>
      <mu-tab>复诊建议</mu-tab>
      <mu-tab>复诊记录</mu-tab>
    </mu-tabs>

    <template v-if="active == 0">
      <div class="screen">
        <div class="screen_item" @click="showPickerType = true">
          <p>报告类型</p>
          <i class="iconfont icon-shangxiaxuanze"></i>
        </div>

        <template>
          <van-popup v-model="showPickerType" position="bottom">
            <van-picker
                show-toolbar
                value-key="dictValue"
                :columns="$store.state.type"
                @confirm="onConfirmType"
                @cancel="showPickerType = false"
            />
          </van-popup>
        </template>

        <div class="screen_item" @click="showPickerTime= true">
          <p>体检时间</p>
          <i class="iconfont icon-shangxiaxuanze"></i>
        </div>

        <template>
          <van-calendar :default-date="null"
                        :min-date="minDate"
                        :max-date="maxDate"
                        v-model="showPickerTime"
                        :show-confirm="false"
                        type="range"
                        @confirm="onConfirmTime" />
        </template>

      </div>


      <template v-if="this.follow_list.length != 0">
        <ul class="follow_list">
          <mu-load-more :loaded-all="followloadall" :loading="followloading" @load="followload">
            <li class="follow_list_li" v-for="item in follow_list" :key="item.reportId" >
              <div class="title">
                <p class="blue">{{ $store.state.type.filter((items) => { return items.dictKey == item.reportType })[0].dictValue }}报告 - {{ item.name }}</p>
                <p>报告生成时间：<br/>{{ item.createTime }}</p>
              </div>
              <ul class="content">
                <li v-for="(items,index) in item.followAdvice" :key="index" >
                  <h2>{{ index + 1 }}.{{ items.deptName }}</h2>
                  <div class="reason" v-for="(itemss,indexs) in items.adviceList" :key="indexs" >
                    <p>
                      <span>诊断原因</span>
                      {{ itemss.reason }}
                    </p>
                    <p>
                      <span>医生建议</span>
                      {{ itemss.advice }}
                    </p>
                    <p>
                      <span>建议复诊时间</span>
                      {{ itemss.reviewDate }}
                    </p>
                  </div>
                </li>
              </ul>
              <div class="button">
                <mu-button @click="deta(item.reportId)" color="primary" round >预约复诊</mu-button>
              </div>
            </li>
          </mu-load-more>
        </ul>
      </template>

      <template v-else>
        <NoList>
          <template #text>
            <p>暂无数据</p>
          </template>
        </NoList>
      </template>


    </template>

    <template v-if="active == 1">
      <template v-if="record_list.length != 0">
        <ul class="record">
          <mu-load-more :loaded-all="recordloadall" :loading="recordloading" @load="recordload">
            <li v-for="item in record_list" :key="item.reviewId" @click="link_result(item.reviewId)" >
              <div class="title">
                <p class="title_name">就诊人</p>
                <p>{{ item.name }}</p>
              </div>
              <div class="item">
                <span>预约时间</span>
                <p>{{ item.appointDate }}  {{ item.appointPeriod }}</p>
              </div>
              <div class="item">
                <span>预约地点</span>
                <p>{{ item.appointHospital }}   {{ item.appointDept }}</p>
              </div>
              <div class="item">
                <span>预约状态</span>
                <p>{{ item.status }}</p>
              </div>
            </li>
          </mu-load-more>
        </ul>
      </template>

      <template v-else>
        <NoList>
          <template #text>
            <p>暂无数据</p>
          </template>
        </NoList>
      </template>

    </template>


  </div>
</template>

<script>
export default {
  name: "Follow",
  data() {
    return{
      active: 0,
      showPickerType: false,
      showPickerTime: false,
      minDate: null,
      maxDate: null,
      json: {
        pageNum: 1,
        pageSize: 10,
        reportType: null, // 报告类型
        startDate: null, // 开始日期
        endDate: null, // 结束日期
      },
      follow_list: [],
      record_list: [],
      followloadall: false,
      followloading: false,
      recordloadall: false,
      recordloading: false,
    }
  },
  created() {

    var myDate = new Date();
    var tYear = myDate.getFullYear();
    this.minDate= new Date(tYear,0,1);

    // var day1 = new Date();
    // day1.setTime(day1.getTime()-24*60*60*1000);
    // this.maxDate= new Date(day1.getFullYear(),day1.getMonth(),day1.getDate())
    this.maxDate= new Date();

    this.$store.dispatch("setType");

    this.get_list(this.json);

  },
  mounted() {

  },
  methods: {
    followload() {
      console.log("load");
    },
    recordload() {
      console.log("load");
    },
    get_list(y) {
      if(this.active == 0) {
        this.$get("follow",y)
          .then(res => {
            if(res) {
              console.log(res);

              this.followloadall= !res.data.hasNextPage;
              this.followloading= false;

              res.data.list.forEach((item) => {
                this.follow_list.push(item);
              })

            }
          })
      }else {
        this.$get("follow/appointment",y)
          .then(res => {
            if(res) {
              console.log(res);

              this.recordloadall= !res.data.hasNextPage;
              this.recordloading= false;

              res.data.list.forEach((item) => {
                this.record_list.push(item);
              })

            }
          })
      }
    },
    onConfirmTime(e) {
      // console.log(e);
      this.follow_list= [];
      this.json.startDate= this.formatDate(e[0]);
      this.json.endDate= this.formatDate(e[1]);
      this.showPickerTime= false;

      this.get_list(this.json);

    },
    onConfirmType(e) {
      // console.log(e);
      this.follow_list= [];
      this.json.reportType= e.dictKey;
      this.showPickerType= false;

      this.get_list(this.json);

    },
    tabChange() {

      this.follow_list= [];
      this.record_list= [];

      this.json.pageNum= 1;
      this.json.pageSize= 10;
      this.json.reportType= null;
      this.json.startDate= null;
      this.json.endDate= null;
      this.get_list(this.json);
    },
    // 上传
    upload() {
      this.$router.push({
        path: "/FollowUpload"
      })
    },
    // 预约
    deta(e) {
      this.$router.push({
        path: "/FollowDeta",
        query: {
          id: e
        }
      })
    },
    // 预约结果
    link_result(e) {
      this.$router.push({
        path: "/FollowResult",
        query: {
          id: e
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
 @import "../../style/Nav/Follow";
</style>
